const extractLinkData = require("./extractLinkData");

module.exports = function transformButtonsData(entity, sitemap) {
	const { attributes } = entity;

	let links = [];

	const primary =
		attributes && attributes.field_primary_button
			? extractLinkData(attributes.field_primary_button, sitemap)
			: null;
	const secondary =
		attributes && attributes.field_secondary_button
			? extractLinkData(attributes.field_secondary_button, sitemap)
			: null;

	if (primary) {
		links.push({ ...primary, color: "primary" });
	}
	if (secondary) {
		links.push({ ...secondary, color: "secondary" });
	}

	let more_links =
		attributes.field_buttons &&
		Array.isArray(attributes.field_buttons) &&
		attributes.field_buttons.length > 0
			? attributes.field_buttons
			: null;
	if (more_links) {
		more_links = more_links.map((l) => extractLinkData(l, sitemap));
		links = [...links, ...more_links];
	}
	return { id: entity.id, type: entity.type, singleColumn: false, links };
};
